import {createApp} from 'vue'
import App from './App.vue'
import Router from './router'
import 'normalize.css/normalize.css'
import 'animate.css'; //动画库
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/styles/site.less'
import './assets/styles/site.less'

const app = createApp(App)

app.use(ElementPlus)
app.use(Router)

app.mount('#app')
